import { Routes } from "@angular/router";
import { AuthorizationGuard } from "@fpr/core/guards/authorization.guard";
import { RedirectGuard } from "@fpr/core/guards/redirect.guard";
import { RouteData } from "@fpr/core/models/route.models";
import { Intent } from "@fpr/core/models/session.models";
import { bookingRoutes } from "./app-booking.routes";
import { cancelRoutes } from "./app-cancel.routes";

const routes: Routes = [
    {
        path: "",
        canActivate: [RedirectGuard],
        component: RedirectGuard,
        children: bookingRoutes,
        data: {
            intent: Intent.BOOKING,
            externalUriConfig: "ANNUAL_PASS_CME_URI",
        } as RouteData,
    },
    {
        path: "cancel",
        children: cancelRoutes,
        data: {
            intent: Intent.CANCEL,
        } as RouteData,
    },
    {
        path: "just-a-moment",
        loadChildren: () => import("./+conflict/conflict.routes"),
        canActivate: [AuthorizationGuard],
        data: {
            pageTitle: "Just a Moment",
            analyticsPageKey: "wdw.site.admissionreservation.not-so-fast",
            analyticsAutoTrack: false,
        } as RouteData,
    },
    {
        path: "details",
        loadChildren: () =>
            import("./+reservation-details/reservation-details.routes"),
        canActivate: [AuthorizationGuard],
        data: {
            pageTitle: "Reservation Details",
            returnToExternal: "/plan",
            analyticsPageKey: "wdw.site.admissionreservation.details",
            analyticsAutoTrack: false,
        } as RouteData,
    },
    {
        path: "experience-access/details",
        loadChildren: () =>
            import("./+experience-access-details/experience-access-details.routes"),
        canActivate: [AuthorizationGuard],
        data: {
            pageTitle: "Experience Access Details",
            returnToExternal: "/plan",
            analyticsPageKey:
                "wdw.site.admissionreservation.experienceaccessdetails",
            analyticsAutoTrack: false,
        } as RouteData,
    },
    {
        path: "error",
        loadChildren: () => import("./+error/error.routes"),
    },
    {
        path: "**",
        pathMatch: "full",
        canActivate: [RedirectGuard],
        component: RedirectGuard,
        data: {
            externalUri: "/plan",
        } as RouteData,
    },
];

export default routes;
